import React from 'react';
import moment from 'moment';
import stripTags from 'striptags';

import {itemHasContent} from '../../../../../data/filters/directory/itemHasContent';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useEventNewsLoaded} from '../../../../../data/hooks/news/useEventNewsLoaded';
import {useLastNews} from '../../../../../data/hooks/news/useLastNews';
import ListItem from '../../../../elements/ListItem/ListItem';
import {ListItemContent} from '../../../../elements/ListItem/ListItemContent';
import RightChevron from '../../../../elements/RightChevron/RightChevron';
import SectionLinkedHeader from '../../../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import styles from './RecentNews.module.scss';

const RecentNews = props => {
    const {event} = props,
        i18n = useI18n(),
        loaded = useEventNewsLoaded(event.id),
        [article] = useLastNews(event.id);

    if (!event._isCommunity && (!event.show_info_on_home || event.has_map)) return null;
    if (loaded && !article) return null;

    let description = '';
    if (article) {
        description = stripTags(article.description);
        if (description.length > 100) {
            description = description.substring(0, 200).trim() + ' ...';
        }
    }

    const hasContent = article && itemHasContent(article),
        href = hasContent ? ['.', 'news', article.id].join('/') : null;

    return (
        <div className="content striped">
            <SectionLinkedHeader href={'./notifications'} next color={event.settings.primary_color}>
                {i18n['label.News']}
            </SectionLinkedHeader>
            {!loaded ? (
                <ListItem tagName="div">
                    <ListItemContent>
                        <div style={{backgroundColor: 'lightgray', height: '1em', marginBottom: '1ex'}}></div>
                        <div style={{backgroundColor: 'lightgray', height: '1em', marginBottom: '1ex'}}></div>
                    </ListItemContent>
                </ListItem>
            ) : (
                <ListItem className="" tagName="div" unpadded>
                    <ListItemContent href={href}>
                        <h4 style={{color: event.settings.primary_color}}>{article.title}</h4>
                        <p className={styles.description}>{description}</p>
                        <div className={styles.date}>{moment(article.date_published).format('llll')}</div>
                    </ListItemContent>
                    {/* {hasContent ? <RightChevron /> : null} */}
                </ListItem>
            )}
        </div>
    );
};

export default RecentNews;
